export class SiteInfo {
  appEmail2?: string;
  appEmail: string = '';
  claimEmail: string = '';
  claimsPhoneNumber: string = '';
  customerServiceEmail: string = '';
  customerServicePhoneNumber: string = '';
  dealerSupportPhoneNumber2?: string;
  dealerSupportPhoneNumber: string = '';
  enrollEmail: string = '';
  fax: string = '';
  supportEmail: string = '';
  supportPhone: string = '';
}
